import { useState } from 'react';
import './Hero.css';
import ServiceWizard from '../components/ServiceWizard';
import useMagnetic from '../useMagnetic';
import { servicesData } from '../data/servicesData';

const titleTokens = [
  { t: 'Best', em: true }, { t: 'Branding' }, { t: '&' }, { t: 'Digital' },
  { t: 'Marketing' }, { t: 'Agency' }, { t: 'in' }, { t: 'Trichy' }, { t: '—' },
  { t: 'Driving', em: true }, { t: 'Real', em: true }, { t: 'Business', em: true }, { t: 'Growth', em: true },
];

export default function Hero() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const magPrimary = useMagnetic(0.3);
  const magWizard = useMagnetic(0.3);

  return (
    <>
    <section id="hero" className="hero">
      {/* Aurora mesh gradient layer — slow hue-shifting blobs */}
      <div className="hero-aurora">
        <span className="aurora-blob a1" />
        <span className="aurora-blob a2" />
        <span className="aurora-blob a3" />
      </div>

      {/* Breathing gradient circles */}
      <div className="hero-bg-circles">
        <div className="hbc hbc1" />
        <div className="hbc hbc2" />
        <div className="hbc hbc3" />
      </div>

      {/* Ambient dark gradient behind the text so it always reads clearly */}
      <div className="hero-overlay" />

      <div className="hero-grid">
        <div className="hero-content">
          <h1 className="hero-title-stagger">
            {titleTokens.map((tok, i) => (
              <span
                key={i}
                className={`stag-word${tok.em ? ' em' : ''}`}
                style={{ '--i': i }}
              >
                {tok.t}
              </span>
            ))}
          </h1>
          <p className="hero-sub">
            AerialRoot connects your business to the digital world through AI-driven
            marketing, automation, and analytics — reaching deeper, growing faster.
          </p>
          <div className="hero-btns">
            <a
              href="#/contact"
              className="btn-primary"
              ref={magPrimary.ref}
              onMouseMove={magPrimary.onMouseMove}
              onMouseLeave={magPrimary.onMouseLeave}
            >
              Start Growing Today
            </a>
            <button
              type="button"
              className="btn-wizard"
              ref={magWizard.ref}
              onMouseMove={magWizard.onMouseMove}
              onMouseLeave={magWizard.onMouseLeave}
              onClick={() => setWizardOpen(true)}
            >
              🧭 Find Your Service
            </button>
          </div>
          <div className="hero-trust-strip">
            <span className="hero-trust-item">✓ Full site ownership, no lock-in</span>
            <span className="hero-trust-item">✓ Campaigns live in 48 hrs</span>
            <span className="hero-trust-item">✓ Weekly reports, real numbers</span>
          </div>
        </div>
      </div>

      <ServiceWizard open={wizardOpen} onClose={() => setWizardOpen(false)} />
    </section>

    {/* Scrolling service names strip — sits below the hero, not inside it */}
    <section className="hero-marquee">
      <div className="hero-marquee-track">
        {[...Array(2)].map((_, r) => (
          <span className="hero-marquee-set" key={r}>
            {servicesData.map(s => (
              <span key={s.slug}>
                <span>{s.title}</span><span>•</span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </section>
    </>
  );
}
